module.exports = __webpack_public_path__ + "static/media/Observadores_Ciudadania.a1a191ce.png";